import { render, staticRenderFns } from "./ProductContentBanner.vue?vue&type=template&id=705a3220&scoped=true"
import script from "./ProductContentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductContentBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductContentBanner.vue?vue&type=style&index=0&id=705a3220&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a3220",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductContentBannerPoints: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@3/components/sections/productSection/ProductContentBannerPoints.vue').default})
